import Loader from '@anm/components/Loader';
import { FC } from 'react';
import styled from 'styled-components';

const LoaderWrapper = styled(Loader)`
  margin-top: 150px;
`;

const TeamLoader: FC = () => <LoaderWrapper color="blue" size="large" />;

export default TeamLoader;
